import { render } from "./CoBrandGrove.vue?vue&type=template&id=e6bcdca6&scoped=true"
import script from "./CoBrandGrove.vue?vue&type=script&lang=js"
export * from "./CoBrandGrove.vue?vue&type=script&lang=js"

import "./CoBrandGrove.vue?vue&type=style&index=0&id=e6bcdca6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6bcdca6"]])

export default __exports__